import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { reducer } from './reducer';
import { EffectsModule } from '@ngrx/effects';
import { GasPriceStoreEffects } from './effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature('gasPrice', reducer),
        EffectsModule.forFeature([GasPriceStoreEffects])
    ],
    providers: []
})
export class GasPriceStoreModule {}
